// extracted by mini-css-extract-plugin
export default {"autoComplete":"X5-z","error":"Y5-z","disabled":"Z5-z"};